<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">微笑领红包</div>
          <div class="contentBottom">
            <div>基于FACE-ID，提升会员转化的人脸互动游戏</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div
      class="topText"
    >以轻交互游戏为载体与顾客互动，嵌入智能视觉算法为核心，对线下零售场景中的人、货、场等要素进全面数字化升级，实现线下零售会员体系从数据采集、存储、分析到优化提升的服务闭环，提供完整的端 （采集终端）到端（展⽰终端）的智能服务。智能终端所感知的综合数据进行机器学习建模，帮助店铺构建精准用户画像，帮助导购为会员提供个性化营销服务。</div>

    <!-- start -->
    <!-- <div class="contentFlex">
      <div class="contentBox">
        <img v-lazy="wawa1" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa2" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa3" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa4" alt>
      </div>
    </div>-->
    <!-- end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">适用场景</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- iconFlex start -->
    <div class="iconParent">
      <div class="iconFlex">
        <div class="iconBox">
          <img v-lazy="wawaIcon1" alt>
          <div class="iconText">入口引流</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon2" alt>
          <div class="iconText">开业庆典</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon3" alt>
          <div class="iconText">节日促销</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon4" alt>
          <div class="iconText">线下活动</div>
        </div>
      </div>
    </div>
    <!-- iconFlex end -->
    <!-- 产品特色 start -->
    <!-- start -->
    <div class="titleBox" style="margin-top:140px">
      <div class="anliTitle">产品特色</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <div class="teSeParent">
      <div class="teSeLeft">
        <img v-lazy="teSeImg1" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">微笑打分，趣味化引流</div>
        <div class="teSeText">用人脸识别技术，微笑值打分并发放红包的方式，吸引顾客参与。趣味交互过程，吸引更多路人驻足并参与。</div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">基于FACE-ID，线下会员转化</div>
        <div class="teSeText">游戏过程中，扑捉人脸信息，通过面部识别算法，判断会员与否，并引导新人入会，及原有会员数据细化。</div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img v-lazy="teSeImg2" class="teSeImg" alt>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft">
        <img v-lazy="teSeImg3" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">精准营销</div>
        <div
          class="teSeText"
        >通过智能导购算法，基于会员的画像、消费偏好等数据，实现精准化产品推荐及活动推荐。
（*推送策略需根据业务逻辑定制。）</div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">数据统计，提供效果评估及决策依据</div>
        <div class="teSeText">多维数据自动统计（识别人数、交互人数、领红包人次、自动推荐购买人次等），量化线下效果，持续迭代。所有数据均基于屏幕ID自动统计，便于商家进行区域化营销效果评估。</div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img v-lazy="teSeImg4" class="teSeImg" alt>
      </div>
    </div>
    <!-- 管理平台 start -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">管理平台</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="pingTaiFlex">
      <div class="pingtaiBox childImg">
        <img v-lazy="adminImg1" alt>
      </div>
      <div class="pingtaiBox childImg">
        <img v-lazy="adminImg2" alt>
      </div>
      <div class="pingtaiBox childImg">
        <img v-lazy="adminImg3" alt>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">硬件选型</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="pingTaiFlex marginTop70 borderParent">
      <div class="pingtaiBox borderCss">
        <img v-lazy="MPDPImgLeft4" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">壁挂一体机</div> -->
      </div>
      <div class="pingtaiBox borderCss">
        <img v-lazy="MPDPImgRight4" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">立式一体机</div> -->
      </div>
      <div class="pingtaiBox borderCss">
        <img v-lazy="storageBottom3" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">数拓盒子</div> -->
      </div>
      <div class="pingtaiBox" >
        <img v-lazy="xuanXing4" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">数拓盒子</div> -->
      </div>
    </div>
    <!-- end -->
    <!-- 管理平台 end -->
    <!-- 产品特色 end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/smileTop.png";
import wawa1 from "@/assets/images/storage1.png";
import wawa2 from "@/assets/images/storage2.png";
import wawa3 from "@/assets/images/storage3.png";
import wawa4 from "@/assets/images/storage4.png";

import wawaIcon1 from "@/assets/images/bigWheelIcon1.png";
import wawaIcon2 from "@/assets/images/bigWheelIcon2.png";
import wawaIcon3 from "@/assets/images/bigWheelIcon3.png";
import wawaIcon4 from "@/assets/images/bigWheelIcon4.png";

import teSeImg1 from "@/assets/images/smile1.png";
import teSeImg2 from "@/assets/images/smile2.png";
import teSeImg3 from "@/assets/images/smile3.png";
import teSeImg4 from "@/assets/images/smile4.png";

import adminImg1 from "@/assets/images/pingTaiBox1.png";
import adminImg2 from "@/assets/images/pingTaiBox2.png";
import adminImg3 from "@/assets/images/pingTaiBox3.png";

import MPDPImgLeft4 from "@/assets/images/xuanXing1.png";
import MPDPImgRight4 from "@/assets/images/xuanXing2.png";
import storageBottom3 from "@/assets/images/xuanXing3.png";
import xuanXing4 from "@/assets/images/xuanXing4.png";
import storageBottom4 from "@/assets/images/storageBottom4.png";
import Bread from "@/components/bread.vue";
export default {
  name: "ProductSmile",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["产品", "星辰云货架"],
      bgImg: bgImg,
      wawa1: wawa1,
      wawa2: wawa2,
      wawa3: wawa3,
      wawa4: wawa4,
      wawaIcon1: wawaIcon1,
      wawaIcon2: wawaIcon2,
      wawaIcon3: wawaIcon3,
      wawaIcon4: wawaIcon4,
      xuanXing4: xuanXing4,
      storageBottom3: storageBottom3,
      storageBottom4: storageBottom4,
      teSeImg1: teSeImg1,
      teSeImg2: teSeImg2,
      teSeImg3: teSeImg3,
      teSeImg4: teSeImg4,
      adminImg1: adminImg1,
      adminImg2: adminImg2,
      adminImg3: adminImg3,
      MPDPImgLeft4: MPDPImgLeft4,
      MPDPImgRight4: MPDPImgRight4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.topText {
  width: 60%;
  margin: auto;
  max-width: 890px;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 74px;
  margin-bottom: 80px;
}

/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 179px;
}

/* end */
.contentFlex {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: space-around;
}
.contentBox {
  width: 25%;
  text-align: center;
}
.contentBox img {
  width: 90%;
  max-width: 255px;
  margin: auto;
}
.iconParent {
  background: rgba(238, 238, 238, 1);
  margin-top: 56px;
}
.iconFlex {
  display: flex;
  width: 70%;
  margin: auto;
  padding: 84px 0 60px;
}
.iconBox {
  width: 33%;
  text-align: center;
}
.iconBox img {
  width: 80%;
  max-width: 86px;
}
.iconText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 20px;
}
.teSeParent::after {
  content: "";
  display: block;
  clear: both;
}
.teSeParent {
  width: 70%;
  margin: auto;
  margin-top: 75px;
  
}
.teSeLeft {
  width: 50%;
  float: left;
}
.teSeRight {
  width: 42%;
  float: right;
}
.teSeImg {
  width: 100%;
  /* max-width: 769px;  */
}
.teSeTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  margin-top: 20%;
}
.teSeText {
  width: 90%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 5%;
  line-height: 30px;
}
.teSeLeftTwo {
  width: 42%;
  padding-left: 6.5%;
}
.teSeRightTwo {
  width: 50%;
}
.imgBox {
  width: 70%;
  margin: auto;
}
.imgBox::after {
  content: "";
  display: block;
  clear: both;
}
.imgLeft {
  width: 49%;
  float: left;
}
.imgRight {
  width: 49%;
  float: right;
  text-align: right;
}
.imgXiaImg {
  width: 100%;
  max-width: 584px;
}
.marginTop2 {
  margin-top: 2%;
}
.spicial {
  background: #eeeeee;
  margin-top: 54px;
}
.positionBoxParent {
  position: relative;
}
.positionBox {
  position: absolute;
  bottom: 15px;
  text-align: center;
  width: 370px;
  left: calc(50% - 185px);
}
.positionTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 33px;
}
.positionText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(106, 106, 106, 1);
}
.imgSmallImg {
  width: 80%;
  /* max-width: 481px; */
  margin-top: 49px;
}
.minimgBox {
  /* min-width: 886px; */
}
.pingTaiFlex {
  width: 70%;
  margin: auto;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.pingtaiBox {
  flex-grow: 1;
  text-align: center;
}
.pingtaiBoxImg{
  width: 100%;
}
.childImg {
  width: 33%;
}
.childImg img {
  width: 99%;
}
.pingtaiBoxText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
.marginTop70 {
  margin-top: 70px;
}
.borderParent {
  border: 1px solid rgba(107, 107, 107, 1);
}
.borderCss {
  /* padding: 20px 0; */
  border-right: 1px solid rgba(107, 107, 107, 1);
}
</style>



// WEBPACK FOOTER //
// src/view/ProductSmile.vue